import React, {useEffect, useState} from 'react';
import axios from 'axios';
import SegmentationDetailsModal from './SegmentationDetailsModal';
import urlList from '../../reducers/propertiesReducer';
import getAxiosConfig from '../../utils/axiosConfig';
import SegmentationForm from './SegmentationCreation';

const SegmentationsList = (props) => {
    const [segmentations, setSegmentations] = useState([]);
    const [selectedSegmentation, setSelectedSegmentation] = useState(null);
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
    const [isSegmentationFormOpen, setIsSegmentationFormOpen] = useState(false);
    const [selectedSegmentationForUpdate, setSelectedSegmentationForUpdate] = useState(null);
    const [searchInput, setSearchInput] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchSegmentations();
    }, []);

    const fetchSegmentations = () => {
        setIsLoading(true);
        axios
            .get(urlList().segmentationUrl + '/getAllSegmentations', getAxiosConfig())
            .then((response) => {
                setSegmentations(response.data);
            })
            .catch((error) => {
                console.error('Error fetching segmentations:', error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const openDetailsModal = (segmentation) => {
        setSelectedSegmentation(segmentation);
        setIsDetailsModalOpen(true);
    };

    const closeDetailsModal = () => {
        setIsDetailsModalOpen(false);
    };

    const openSegmentationForm = (segmentation) => {
        setIsSegmentationFormOpen(true);
        setSelectedSegmentationForUpdate(segmentation);
    };

    const closeSegmentationForm = () => {
        setIsSegmentationFormOpen(false);
        setSelectedSegmentationForUpdate(null);
        fetchSegmentations();
    };

    const handleSearchInputChange = (event) => {
        setSearchInput(event.target.value);
    };

    const handleSaveSegmentation = () => {
        fetchSegmentations();
    };

    const filteredSegmentations = segmentations.filter((segmentation) =>
        segmentation.segmentationName.toLowerCase().includes(searchInput.toLowerCase())
    );

    return (
        <div className="segmentations-list">
            <h2>Segmentations</h2>
            <div>
                <input
                    type="text"
                    placeholder="Search by Group name"
                    value={searchInput}
                    onChange={handleSearchInputChange}
                />
            </div>
            <ul>
                {filteredSegmentations.map((segmentation) => (
                    <li key={segmentation.segmentationId + '_' +segmentation.segmentationType}>
                        <div>
                            <strong></strong> {segmentation.segmentationName}
                        </div>
                        <div className="segmentations-list-button-box">
                            <button onClick={() => openDetailsModal(segmentation)}>View Details</button>
                            <button onClick={() => openSegmentationForm(segmentation)}
                            disabled={props.isReadOnly}>
                                Update Segmentation
                            </button>
                        </div>
                    </li>
                ))}
            </ul>

            {isSegmentationFormOpen && (
                <SegmentationForm
                    onCancel={closeSegmentationForm}
                    segmentationId={selectedSegmentationForUpdate?.segmentationId}
                    segmentationType={selectedSegmentationForUpdate?.segmentationType}
                    groupName={selectedSegmentationForUpdate?.segmentationName}
                    isUpdateForm={true}
                    onSegmentationChange={handleSaveSegmentation}
                    isLoading={isLoading}
                />
            )}

            <SegmentationDetailsModal
                isOpen={isDetailsModalOpen}
                onClose={closeDetailsModal}
                segmentation={selectedSegmentation}
                groupName={selectedSegmentation?.segmentationName}
                segmentationType={selectedSegmentation?.segmentationType}
            />
        </div>
    );
};

export default SegmentationsList;




